// hooks/useApiService.js
import { useState, useEffect, useCallback } from 'react';
import apiService from '../services/ApiService.js';

const useApiService = (url, method = 'GET', body = null, deps = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const token = localStorage.getItem('jwtToken');

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      let response;
      switch (method) {
        case 'GET':
          response = await apiService.get(url, token);
          break;
        case 'POST':
          response = await apiService.post(url, token, body);
          break;
        case 'PUT':
          response = await apiService.put(url, token, body);
          break;
        case 'DELETE':
          response = await apiService.delete(url, token);
          break;
        default:
          throw new Error('Unsupported request method');
      }
      setData(response);
    } catch (error) {
      setError(error);
    } finally {
      setLoading(false);
    }
  }, [url, method, body, token]);

  useEffect(() => {
    fetchData();
  }, [fetchData, ...deps]);

  return { data, loading, error, refetch: fetchData };
};

export default useApiService;
